import { UNKNOWN_ERROR } from 'api/payments/cashier';
import { handleActions } from 'redux-actions';
import { CONFIGURE, CREATE_ORDER, INIT_SDK, SELECT_METHOD, setError, statusChange } from '../actions/payment';

const initialState = {
  config: null,
  error: null,
  orderId: null,
  paymentType: null,
  paymentMethods: null,
  selectedMethod: null,
};

function handleError(state, { payload: error }) {
  if (error && error.params) {
    error = error.params;
  }
  if (_.isError(error)) {
    error = error.message;
  }
  if (_.isObject(error)) {
    error = _.get(error, 'data.error_description');
  }
  if (!error || !_.isString(error)) {
    error = UNKNOWN_ERROR;
  }
  return { ...state, error };
}

function handleStatusChange(state, { payload: status }) {
  return { ...state, status };
}

export default handleActions({
  [CONFIGURE](state, { payload }) {
    return {
      ...state,
      config: payload,
    };
  },

  [CREATE_ORDER.START](state, { payload }) {
    return {
      ...state,
      paymentType: _.get(payload, 'params.paymentType'),
      orderId: null,
      error: null,
      paymentMethods: null,
      selectedMethod: null,
    };
  },

  [CREATE_ORDER.SUCCESS](state, { payload }) {
    return {
      ...state,
      orderId: _.get(payload, 'params.orderId'),
    };
  },

  [INIT_SDK.SUCCESS](state, { payload }) {
    return {
      ...state,
      paymentMethods: _.get(payload, 'params.paymentMethods', []),
    };
  },

  [CREATE_ORDER.FAIL]: handleError,

  [INIT_SDK.FAIL]: handleError,

  [setError]: handleError,

  [SELECT_METHOD](state, { payload }) {
    return {
      ...state,
      error: null,
      selectedMethod: payload,
    };
  },
  [statusChange]: handleStatusChange,
}, initialState);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/payment.js